var map = {
	"./IMG_0781.jpg": 7156,
	"./IMG_0786.jpg": 4943,
	"./IMG_0794.jpg": 2638,
	"./IMG_0801.jpg": 647,
	"./IMG_0805.jpg": 1403,
	"./IMG_0807.jpg": 585,
	"./IMG_0824.jpg": 9476,
	"./IMG_0828.jpg": 1576,
	"./IMG_0834.jpg": 3379,
	"./IMG_4210.jpg": 9387,
	"./IMG_4220.jpg": 7366,
	"./IMG_8324.jpg": 2919,
	"./IMG_8325.jpg": 7114,
	"./IMG_8329.jpg": 1398,
	"./campus1.JPG": 2037,
	"./campus2.png": 5615,
	"assets/CampusImages/IMG_0781.jpg": 7156,
	"assets/CampusImages/IMG_0786.jpg": 4943,
	"assets/CampusImages/IMG_0794.jpg": 2638,
	"assets/CampusImages/IMG_0801.jpg": 647,
	"assets/CampusImages/IMG_0805.jpg": 1403,
	"assets/CampusImages/IMG_0807.jpg": 585,
	"assets/CampusImages/IMG_0824.jpg": 9476,
	"assets/CampusImages/IMG_0828.jpg": 1576,
	"assets/CampusImages/IMG_0834.jpg": 3379,
	"assets/CampusImages/IMG_4210.jpg": 9387,
	"assets/CampusImages/IMG_4220.jpg": 7366,
	"assets/CampusImages/IMG_8324.jpg": 2919,
	"assets/CampusImages/IMG_8325.jpg": 7114,
	"assets/CampusImages/IMG_8329.jpg": 1398,
	"assets/CampusImages/campus1.JPG": 2037,
	"assets/CampusImages/campus2.png": 5615
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4240;